/* cl-kcart.js — gaveta de carrinho da copia: replica da gaveta do app Kaching Cart da loja dele
   (mesmas classes `kaching-cart__*`, CSS do app em assets/cl-kcart.css). Montada pela secao
   sections/cl-cart-drawer.liquid (layout/theme.liquid, toda pagina).

   API: window.CLKC.open(), .close(), .refresh() -> Promise<cart>, .add(items) -> Promise.
   Abre no clique do icone do carrinho e depois de QUALQUER "adicionar ao carrinho" (form nativo do
   Shrine, botoes das secoes copiadas, fetch('/cart/add') de outro script).

   Modulos na ordem da config dele: barra de niveis (frete gratis / brinde), itens (com seletor de
   variante e quantidade), brinde, upsell "Un complement ideal..."; rodape: cupom, reducoes, total,
   checkout. O contador "Vos offres sont reservees pour 10:00" do app NAO existe aqui por pedido
   do operador (sem timer na loja). */
(function () {
  'use strict';
  if (window.CLKC) return;
  var CL = window.CLKC = {};
  var root, body, foot, heading, cfg, icons, cart = null, busy = false, pcache = {}, giftLock = false;

  function $(s, el) { return (el || root).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(cents) {
    var f = cfg.money || 'R$ {{amount_with_comma_separator}}';
    var v = (Math.round(cents) / 100).toFixed(2), n = Math.round(cents / 100).toString();
    function grp(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var p = v.split('.');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return grp(p[0], '.') + ',' + p[1];
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, '.');
      if (k === 'amount_no_decimals') return grp(n, ',');
      if (k === 'amount_with_apostrophe_separator') return grp(p[0], "'") + '.' + p[1];
      return grp(p[0], ',') + '.' + p[1];
    });
  }
  function money(c) { return '⁨<span class="notranslate">' + esc(fmt(c)) + '</span>⁩'; }
  function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function req(url, data) {
    return fetch(url, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CL-Cart': '1' },
      body: data ? JSON.stringify(data) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('Erreur ' + r.status));
        return j;
      });
    });
  }
  function product(handle) {
    if (!pcache[handle]) {
      pcache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { delete pcache[handle]; return null; });
    }
    return pcache[handle];
  }
  // brinde do app Kaching Bundles real (retrabalho 2026-10-14): a linha traz `__kaching_bundles` com "gift"
  function isAppGift(it) { var k = it.properties && it.properties.__kaching_bundles; return !!k && /"gift"\s*:/.test(k); }
  function isGift(it) { return it.properties && (it.properties._cl_gift || it.properties._cl_kit_gift || isAppGift(it)); }
  function isKitGift(it) { return it.properties && it.properties._cl_kit_gift; }

  /* ---------------------------------------------------------- seletores de variante --- */
  function selects(p, variant) {
    if (!p || !p.options || p.variants.length < 2) return '';
    var html = '';
    p.options.forEach(function (o, i) {
      html += '<select class="kaching-cart-selector" name="' + esc(o.name) + '" data-option-name="' + esc(o.name) + '" data-index="' + i + '" aria-label="' + esc(o.name) + '" style="cursor: pointer;">';
      o.values.forEach(function (v, vi) {
        // valor sem nenhuma variante disponivel combinando com as outras opcoes atuais -> disabled
        var ok = p.variants.some(function (x) {
          if (!x.available) return false;
          for (var j = 0; j < p.options.length; j++) {
            if (j === i) { if (x.options[j] !== v) return false; }
            else if (variant && x.options[j] !== variant.options[j]) return false;
          }
          return true;
        });
        html += '<option data-option-value-index="' + vi + '" value="' + esc(v) + '"' + (variant && variant.options[i] === v ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(v) + '</option>';
      });
      html += '</select>';
    });
    return html;
  }
  function optionNames(p) {
    if (!p || !p.options || p.variants.length < 2) return '';
    return '<span class="kaching-cart-item__option-names">' + esc(p.options.map(function (o) { return o.name; }).join(', ')) + ':</span>';
  }
  function pick(p, box) {
    var vals = [].map.call(box.querySelectorAll('select.kaching-cart-selector'), function (s) { return s.value; });
    var exact = p.variants.filter(function (v) { return vals.every(function (x, i) { return v.options[i] === x; }); })[0];
    if (exact && exact.available) return exact;
    // combinacao indisponivel: a 1a variante disponivel que mantem a opcao que acabou de mudar
    return exact || p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
  }

  /* ---------------------------------------------------------------- render --- */
  function tierBar(total) {
    // como o app: niveis em intervalos IGUAIS na barra, preenchimento linear dentro de cada intervalo
    var tiers = cfg.tiers, nt = tiers.length, pct = 0, prev = 0;
    for (var k = 0; k < nt; k++) {
      var th = tiers[k].threshold;
      if (total >= th) { pct = (k + 1) / nt * 100; prev = th; continue; }
      pct = (k + (total - prev) / (th - prev)) / nt * 100; break;
    }
    var next = tiers.filter(function (t) { return total < t.threshold; })[0];
    var unlocked = tiers.filter(function (t) { return total >= t.threshold; });
    var txt = next
      ? '<br>Ajouter <strong>' + money(next.threshold - total) + '</strong> pour débloquer: <strong>' + esc(next.title) + '</strong> !'
      : '<strong>' + esc(unlocked[unlocked.length - 1].title) + '</strong> débloqué(e) ! ';
    var ic = tiers.map(function (t, i) {
      var last = i === nt - 1, pos = (i + 1) / nt * 100;
      var st = last ? 'right: -2px; align-items: flex-end; text-align: right; max-width: 25%;'
                    : 'left: ' + pos + '%; transform: translateX(-50%); align-items: center; text-align: center; max-width: 25%;';
      var on = total >= t.threshold;
      return '<div class="kaching-cart__tiered-promotions-bar-icon' + (on ? ' kaching-cart__tiered-promotions-bar-icon--unlocked' : '') + '" style="' + st + '">' +
        icons.step + '<div class="kaching-cart__tiered-promotions-bar-icon-tooltip" style="' + (last ? 'align-items: flex-end; text-align: right;' : 'align-items: center; text-align: center;') + '">' +
        (t.type === 'gift' ? icons.gift : icons.truck) +
        '<span class="kaching-cart__tiered-promotions-bar-icon-tooltip-title" style="color: rgb(48, 48, 48);">' + esc(t.title) + '</span></div></div>';
    }).join('');
    return '<div class="kaching-cart__module"><div class="kaching-cart__tiered-promotions-bar" style="padding-bottom: 71px;">' +
      '<p class="kaching-cart__tiered-promotions-bar-text"><span>' + txt + '</span></p>' +
      '<div class="kaching-cart__tiered-promotions-bar-progress-container" dir=""><div class="kaching-cart__tiered-promotions-bar-icons">' + ic + '</div>' +
      '<div class="kaching-cart__tiered-promotions-bar-progress-fill" dir="ltr" data-progress-percentage="' + Math.round(pct) + '" style="width: ' + pct + '%;">&nbsp;</div></div></div></div>';
  }

  function lineHtml(it, p) {
    var variant = p && p.variants.filter(function (v) { return v.id === it.variant_id; })[0];
    var cmp = 0;
    if (variant && variant.compare_at_price > variant.price) cmp = variant.compare_at_price * it.quantity;
    if (it.original_line_price > it.final_line_price) cmp = Math.max(cmp, it.original_line_price);
    var old = cmp > it.final_line_price ? '<s class="kaching-cart-item__total-old">' + money(cmp) + '</s> ' : '';
    var url = esc(it.url);
    return '<div class="kaching-cart-item-container"><div class="kaching-cart-item" data-key="' + esc(it.key) + '" data-product-handle="' + esc(it.handle) + '" data-variant-id="' + it.variant_id + '" data-qty="' + it.quantity + '">' +
      '<div class="kaching-cart-item__image-container"><a class="kaching-cart-item__link" href="' + url + '">' +
      (it.image ? '<img class="kaching-cart-item__image" loading="lazy" src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '">' : '') + '</a></div>' +
      '<div class="kaching-cart-item__content"><div class="kaching-cart-item__content-left"><div class="kaching-cart-item__info">' +
      '<a class="kaching-cart-item__title" href="' + url + '">' + esc(it.product_title) + '</a>' + optionNames(p) +
      (p && p.variants.length > 1 ? '<div class="kaching-cart-item__variant-selectors"><div class="kaching-variant-selectors-row"><div class="kaching-variant-selectors-row__selectors">' + selects(p, variant) + '</div></div></div>' : '') +
      '</div><div class="kaching-cart-item__quantity-controls">' +
      '<button type="button" class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--decrement" data-kc-minus aria-label="Diminuer la quantité">' + icons.minus + '</button>' +
      '<input class="kaching-cart-item__quantity-input" type="number" name="kaching-cart-quantity" aria-label="Quantité" min="1" step="1" value="' + it.quantity + '" data-kc-qty>' +
      '<button type="button" class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--increment" data-kc-plus aria-label="Augmenter la quantité">' + icons.plus + '</button></div></div>' +
      '<div class="kaching-cart-item__content-right"><div class="kaching-cart-item__price-info"><div class="kaching-cart-item__total">' + old +
      '<span class="kaching-cart-item__total-final">' + money(it.final_line_price) + '</span></div></div>' +
      '<button type="button" class="kaching-cart-item__remove-btn" data-kc-remove aria-label="Retirer ' + esc(it.product_title) + ' du panier">' + icons.remove + '</button></div></div></div></div>';
  }

  function giftHtml(it, p) {
    var full = (p && p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : (it.original_price || it.price);
    var free = it.final_line_price === 0;
    return '<div class="kaching-cart__tiered-promotions-bar-items"><div class="kaching-promotion-item" data-key="' + esc(it.key) + '">' +
      '<div class="kaching-promotion-item__image-container"><a href="' + esc(it.url) + '">' +
      (it.image ? '<img class="kaching-promotion-item__image" loading="lazy" src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '">' : '') + '</a></div>' +
      '<div class="kaching-promotion-item__content"><div class="kaching-promotion-item__content-left"><div class="kaching-promotion-item__title-container">' +
      '<a class="kaching-promotion-item__title" href="' + esc(it.url) + '"><div style="margin-right: 5px; display: inline-flex; align-items: center;" class="kaching-promotion-item__gift-icon-container">' + icons.gift + '</div><span>' + esc(it.product_title) + '</span></a></div></div>' +
      '<div class="kaching-promotion-item__content-right"><div class="kaching-promotion-item__price"><s class="kaching-promotion-item__price-old">' + money(full * it.quantity) + '</s> ' +
      '<span class="kaching-promotion-item__price-final">' + (free ? 'GRATUIT' : money(it.final_line_price)) + '</span></div></div></div></div></div>';
  }

  function upsellCard(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var price = v.compare_at_price > v.price
      ? '<div class="kaching-product-upsell-item__price-container-discounted"><span class="kaching-product-upsell-item__price-final">' + money(v.price) + '</span> <s class="kaching-product-upsell-item__price-old">' + money(v.compare_at_price) + '</s></div>'
      : '<span class="kaching-product-upsell-item__price-final">' + money(v.price) + '</span>';
    var pimg = (v.featured_image && v.featured_image.src) || p.featured_image;
    return '<li class="kaching-cart__carousel-item kaching-product-upsell-item-container"><div class="kaching-product-upsell-item" data-product-handle="' + esc(p.handle) + '" data-variant-id="' + v.id + '">' +
      '<div class="kaching-product-upsell-item__image-container"><a href="/products/' + esc(p.handle) + '"><img class="kaching-product-upsell-item__image" loading="lazy" src="' + esc(img(pimg, 300)) + '" alt="' + esc(p.title) + '"></a></div>' +
      '<div class="kaching-product-upsell-item__content"><a class="kaching-product-upsell-item__title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
      '<div class="kaching-product-upsell-item__price-container">' + price + '</div>' + optionNames(p) +
      '<div class="kaching-product-upsell-item__footer">' + (p.variants.length > 1 ? '<div class="kaching-product-upsell-item__variant-selector-container">' + selects(p, v) + '</div>' : '') +
      '<button type="button" class="kaching-product-upsell-item__add-to-cart" data-kc-upsell-add>Ajouter au panier</button></div></div></div></li>';
  }
  function carousel(list, title, cls) {
    var ps = list.filter(Boolean);
    if (!ps.length) return '';
    return '<div class="' + cls + '">' + (title ? '<span class="kaching-cart-product-upsell-carousel__title" style="text-align: center;">' + esc(title) + '</span>' : '') +
      '<div class="kaching-cart__carousel"><button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-prev" data-kc-prev aria-label="Précédent" style="display: flex;">' + icons.prev + '</button>' +
      '<ul class="kaching-cart__carousel-list" aria-label="Recommandations">' + ps.map(upsellCard).join('') + '</ul>' +
      '<button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-next" data-kc-next aria-label="Suivant" style="display: flex;">' + icons.next + '</button></div></div>';
  }

  function discountsRow(c, prods) {
    var save = 0, badges = {};
    c.items.forEach(function (it, i) {
      var p = prods[i], v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
      var full = Math.max(it.original_line_price, v && v.compare_at_price ? v.compare_at_price * it.quantity : 0);
      save += Math.max(0, full - it.final_line_price);
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application || {};
        badges[d.value_type === 'percentage' ? Math.round(+d.value) + '%' : (d.title || '')] = 1;
      });
    });
    (c.cart_level_discount_applications || []).forEach(function (d) {
      save += d.total_allocated_amount || 0;
      badges[d.value_type === 'percentage' ? Math.round(+d.value) + '%' : (d.title || '')] = 1;
    });
    if (save <= 0) return '';
    var b = Object.keys(badges).filter(Boolean).map(function (t) {
      return '<div class="kaching-cart__cart-discounts-badge" data-is-discount-code="false">' + icons.tag + ' <span style="max-width: 130px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">' + esc(t) + '</span></div>';
    }).join('');
    return '<div class="kaching-cart__cart-discounts"><div class="kaching-cart__cart-discounts-title">Vos réductions: ' + b + '</div><div class="kaching-cart__cart-discounts-amount">-' + money(save) + '</div></div>';
  }

  function render(c) {
    cart = c;
    var n = c.item_count;
    heading.textContent = cfg.title.replace('{{item_count}}', n);
    root.setAttribute('aria-label', heading.textContent);
    bubble(n);
    var inner = $('.kaching-cart__inner');
    if (!n) {
      inner.classList.add('cl-kc-empty');
      Promise.all(cfg.emptyUpsell.map(product)).then(function (ps) {
        if (cart !== c) return;
        body.innerHTML = '<div class="kaching-cart__inner-empty"><div class="kaching-cart__empty-cart-content"><div class="kaching-cart__empty-cart-top-empty-space"></div>' +
          '<div class="kaching-cart__empty-cart-central-content"><div class="kaching-cart__empty-cart-central-content-main"><div class="kaching-cart__empty-cart-icon">' + icons.bag + '</div>' +
          '<div class="kaching-cart__empty-cart-title">' + esc(cfg.emptyTitle) + '</div>' +
          '<a href="' + esc(cfg.emptyUrl) + '" class="kaching-cart__empty-cart-button">' + esc(cfg.emptyButton) + '</a></div></div>' +
          '<div class="kaching-cart__empty-cart-modules">' + carousel(ps, '', 'kaching-upsell-module--ec-product-upsell') + '</div></div></div>';
        initCarousels();
      });
      foot.innerHTML = '';
      foot.hidden = true;
      return Promise.resolve();
    }
    inner.classList.remove('cl-kc-empty');
    foot.hidden = false;
    var base = c.items.reduce(function (s, it) { return s + (isGift(it) ? 0 : it.final_line_price); }, 0);
    return Promise.all(c.items.map(function (it) { return product(it.handle); })).then(function (prods) {
      if (cart !== c) return;
      var lines = '', gifts = '';
      c.items.forEach(function (it, i) { if (isGift(it)) gifts += giftHtml(it, prods[i]); else lines += lineHtml(it, prods[i]); });
      body.innerHTML = tierBar(base) + '<div class="kaching-cart__module">' + lines + gifts + '</div>' +
        '<div class="kaching-cart__module" style="margin-top: auto;" data-kc-upsell></div>';
      Promise.all(cfg.upsell.map(product)).then(function (ps) {
        var u = $('[data-kc-upsell]');
        if (u && cart === c) { u.innerHTML = carousel(ps, cfg.upsellTitle, 'kaching-upsell-module--product-upsell'); initCarousels(); }
      });
      foot.innerHTML = '<div class="kaching-cart__discount-code"><div class="kaching-cart__discount-code-container">' +
        '<input type="text" name="kaching-cart-discount-code" class="kaching-cart__discount-code-input" placeholder="Code de réduction" aria-label="Code de réduction" data-kc-code>' +
        '<button type="button" class="kaching-cart__discount-code-apply" disabled aria-label="Appliquer" data-kc-apply>Appliquer</button></div>' +
        '<p class="cl-kc-code-msg" data-kc-code-msg hidden></p></div>' + discountsRow(c, prods) +
        '<div class="kaching-cart__subtotal">Total <span>' + money(c.total_price) + '</span></div>' +
        '<a href="/checkout" id="kaching-cart__checkout-button" class="kaching-cart__checkout-button" data-kc-checkout><span class="kaching-cart__checkout-button-text"><span class="kaching-cart__checkout-button-label">' +
        esc(cfg.checkout.split('{{cart_total}}')[0]) + money(c.total_price) + '</span></span></a>';
    });
  }

  /* brinde por nivel: o filet de lavage entra sozinho quando o total (sem o brinde) passa do 2o nivel;
     o preco zero vem do desconto automatico da loja ("Le Filet de lavage Offert") */
  function syncGift(c) {
    if (giftLock) return Promise.resolve(c);
    // brindes do kit (pochette/filet) so ficam enquanto houver 3+ pecas dos produtos com kit
    var kitUnits = c.items.reduce(function (s, it) { return s + ((cfg.kitHandles || []).indexOf(it.handle) >= 0 && !isGift(it) ? it.quantity : 0); }, 0);
    var kg = c.items.filter(isKitGift);
    if (kg.length && kitUnits < 3) {
      var u0 = {}; kg.forEach(function (it) { u0[it.key] = 0; });
      giftLock = true;
      return req('/cart/update.js', { updates: u0 }).then(function () { return req('/cart.js'); }, function () { return c; })
        .then(function (c2) { giftLock = false; return syncGift(c2); });
    }
    var g = cfg.tiers.filter(function (t) { return t.type === 'gift' && t.variant; })[0];
    if (!g) return Promise.resolve(c);
    var base = c.items.reduce(function (s, it) { return s + (isGift(it) ? 0 : it.final_line_price); }, 0);
    var have = c.items.filter(function (it) { return it.properties && it.properties._cl_gift; });
    // o pack do Kaching ja deu o filet de graca: o desconto "Le Filet de lavage Offert" so zera UM filet,
    // o do nivel sairia cobrado -> sem brinde de nivel enquanto houver o do app
    var appHas = c.items.some(function (it) { return isAppGift(it) && it.variant_id === g.variant; });
    var op = null;
    if (appHas && have.length) op = req('/cart/update.js', { updates: have.reduce(function (o, it) { o[it.key] = 0; return o; }, {}) });
    else if (appHas) op = null;
    else if (base >= g.threshold && !have.length && c.item_count) op = req('/cart/add.js', { items: [{ id: g.variant, quantity: 1, properties: { _cl_gift: '1' } }] });
    else if ((base < g.threshold || !c.items.some(function (it) { return !isGift(it); })) && have.length) {
      var upd = {}; have.forEach(function (it) { upd[it.key] = 0; });
      op = req('/cart/update.js', { updates: upd });
    } else if (have.length && have[0].quantity !== 1) op = req('/cart/change.js', { id: have[0].key, quantity: 1 });
    if (!op) return Promise.resolve(c);
    giftLock = true;
    return op.then(function () { return req('/cart.js'); }, function () { return c; })
      .then(function (c2) { giftLock = false; return c2; });
  }

  function refresh() {
    return req('/cart.js').then(syncGift).then(function (c) { render(c); return c; });
  }
  function bubble(n) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (!b && n > 0) { b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>'; a.appendChild(b); }
      if (b) { b.style.display = n > 0 ? '' : 'none'; var s = b.querySelector('span'); if (s) s.textContent = n < 100 ? n : ''; }
    });
  }

  function open() {
    root.classList.add('active');
    root.setAttribute('data-open', 'true');
    document.documentElement.classList.add('cl-kc-lock');
    refresh().catch(function () {});
    setTimeout(function () { var x = $('.kaching-cart__close'); x && x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    root.classList.remove('active');
    root.setAttribute('data-open', 'false');
    document.documentElement.classList.remove('cl-kc-lock');
  }
  function withBusy(p) {
    busy = true; root.classList.add('cl-kc-busy');
    return p.then(function () { return refresh(); }).catch(function (e) { alert(e.message); return refresh(); })
      .then(function () { busy = false; root.classList.remove('cl-kc-busy'); });
  }
  function add(items) {
    return req('/cart/add.js', { items: items }).then(function (r) { return refresh().then(function () { return r; }); });
  }
  CL.open = open; CL.close = close; CL.refresh = refresh; CL.add = add;

  function initCarousels() {
    root.querySelectorAll('.kaching-cart__carousel').forEach(function (c) {
      if (c._kc) return; c._kc = 1;
      var ul = c.querySelector('.kaching-cart__carousel-list');
      function step(d) { var li = ul.querySelector('li'); var w = li ? li.getBoundingClientRect().width : ul.clientWidth; ul.scrollBy({ left: d * w, behavior: 'smooth' }); }
      c.querySelector('[data-kc-prev]').addEventListener('click', function () { step(-1); });
      c.querySelector('[data-kc-next]').addEventListener('click', function () { step(1); });
    });
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('.kaching-cart__close') || t.classList.contains('kaching-cart__overlay') || t === root) { e.preventDefault(); close(); return; }
    var line = t.closest('.kaching-cart-item, .kaching-promotion-item');
    if (line && !busy) {
      var key = line.getAttribute('data-key'), q = +line.getAttribute('data-qty') || 1;
      if (t.closest('[data-kc-remove]')) { e.preventDefault(); withBusy(req('/cart/change.js', { id: key, quantity: 0 })); return; }
      if (t.closest('[data-kc-plus]')) { e.preventDefault(); withBusy(req('/cart/change.js', { id: key, quantity: q + 1 })); return; }
      if (t.closest('[data-kc-minus]')) { e.preventDefault(); withBusy(req('/cart/change.js', { id: key, quantity: Math.max(0, q - 1) })); return; }
    }
    var ub = t.closest('[data-kc-upsell-add]');
    if (ub && !busy) {
      e.preventDefault();
      var card = ub.closest('.kaching-product-upsell-item');
      product(card.getAttribute('data-product-handle')).then(function (p) {
        var v = p ? pick(p, card) : { id: +card.getAttribute('data-variant-id'), available: true };
        if (!v.available) { alert('En rupture de stock'); return; }
        ub.disabled = true;
        withBusy(req('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] })).then(function () { ub.disabled = false; });
      });
      return;
    }
    var ap = t.closest('[data-kc-apply]');
    if (ap && !busy) {
      e.preventDefault();
      var inp = $('[data-kc-code]'), code = inp && inp.value.trim();
      if (!code) return;
      var prev = (cart && cart.discount_codes || []).map(function (d) { return d.code; });
      busy = true;
      req('/cart/update.js', { discount: prev.concat([code]).join(',') }).then(function (c) {
        var ok = (c.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        busy = false;
        return refresh().then(function () {
          var m = $('[data-kc-code-msg]');
          if (m && !ok) { m.hidden = false; m.textContent = 'Le code de réduction que vous avez entré est invalide ou ne peut pas être appliqué à ce panier'; }
        });
      }).catch(function () { busy = false; location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; });
    }
  }
  function onChange(e) {
    var s = e.target;
    if (s.matches('[data-kc-qty]')) {
      var l = s.closest('.kaching-cart-item');
      withBusy(req('/cart/change.js', { id: l.getAttribute('data-key'), quantity: Math.max(0, parseInt(s.value, 10) || 0) }));
      return;
    }
    if (!s.matches('select.kaching-cart-selector')) return;
    var item = s.closest('.kaching-cart-item');
    if (item && !busy) {
      product(item.getAttribute('data-product-handle')).then(function (p) {
        if (!p) return;
        var v = pick(p, item), old = +item.getAttribute('data-variant-id');
        if (!v || v.id === old) return;
        var q = +item.getAttribute('data-qty') || 1, key = item.getAttribute('data-key');
        withBusy(req('/cart/change.js', { id: key, quantity: 0 }).then(function () { return req('/cart/add.js', { items: [{ id: v.id, quantity: q }] }); }));
      });
      return;
    }
    var card = s.closest('.kaching-product-upsell-item');
    if (card) {
      product(card.getAttribute('data-product-handle')).then(function (p) {
        if (!p) return;
        var v = pick(p, card); card.setAttribute('data-variant-id', v.id);
        var box = card.querySelector('.kaching-product-upsell-item__price-container');
        if (box) box.innerHTML = v.compare_at_price > v.price
          ? '<div class="kaching-product-upsell-item__price-container-discounted"><span class="kaching-product-upsell-item__price-final">' + money(v.price) + '</span> <s class="kaching-product-upsell-item__price-old">' + money(v.compare_at_price) + '</s></div>'
          : '<span class="kaching-product-upsell-item__price-final">' + money(v.price) + '</span>';
        if (v.featured_image) { var im = card.querySelector('img'); if (im) im.src = img(v.featured_image.src, 300); }
      });
    }
  }
  function onInput(e) {
    if (e.target.matches('[data-kc-code]')) { var b = $('[data-kc-apply]'); if (b) b.disabled = !e.target.value.trim(); }
  }

  /* qualquer POST bem-sucedido em /cart/add vindo de outro script abre a gaveta */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-CL-Cart'] || (init.headers.get && init.headers.get('X-CL-Cart')));
    var p = _fetch.apply(this, arguments);
    if (!mine && /\/cart\/add(\.js)?(\?|$)/.test(url) && root) {
      p.then(function (r) { if (r.ok) setTimeout(open, 0); }).catch(function () {});
    }
    return p;
  };

  function init() {
    root = document.getElementById('cl-kcart');
    if (!root) return;
    if (root.parentElement !== document.body) document.body.appendChild(root);
    cfg = JSON.parse(document.getElementById('cl-kcart-config').textContent);
    icons = cfg.icons;
    body = $('[data-kc-body]'); foot = $('[data-kc-foot]'); heading = $('.kaching-cart__heading');
    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    root.addEventListener('input', onInput);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('active')) close(); });
    // icone do carrinho do header e qualquer link para /cart
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], [data-drawer-toggle="drawer-cart"], [data-cl-open-cart]');
      if (!a || root.contains(a)) return;
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }, true);
    // form de produto (Shrine nativo ou copiado): adiciona por AJAX e abre a gaveta
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('form[action*="/cart/add"]') || root.contains(f)) return;
      if (f.hasAttribute('data-cl-kit-form')) return;   // kit do buybox: o cl-pdp.js monta as linhas
      e.preventDefault(); e.stopImmediatePropagation();
      var fd = new FormData(f), sub = f.querySelector('[type="submit"]');
      var multi = false; fd.forEach(function (v, k) { if (k.indexOf('items[') === 0) multi = true; });
      if (sub) { sub.disabled = true; sub.classList.add('loading'); }
      var p;
      if (multi) {
        p = _fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); });
      } else {
        var props = {};
        fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
        p = req('/cart/add.js', { items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1), properties: props }] });
      }
      p.then(function () { open(); }).catch(function (x) { alert(x.message); })
        .then(function () { if (sub) { sub.disabled = false; sub.classList.remove('loading'); } });
    }, true);
    try { if (cfg.cart) { render(cfg.cart); } } catch (x) {}
    refresh().catch(function () {});
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
